import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateExplodingFeeScheduleMutation } from "store/queries/explodingFeeSchedule";

import {
  ExplodingFeeScheduleForm,
  IExplodingFeeScheduleFormData,
  INITIAL_FORM_DATA,
} from "./components/ExplodingFeeScheduleForm";

export function CreateExplodingFeeSchedulePage() {
  useDocumentTitle("Create Exploding Fee Schedule");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createRuleset] = useCreateExplodingFeeScheduleMutation();
  const [formData, setFormData] =
    useState<IExplodingFeeScheduleFormData>(INITIAL_FORM_DATA);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await createRuleset({
        providerId: formData.providerId!,
        payerId: formData.payerId!,
        cptCodes: formData.cptCodes,
        totalRateInCents: formData.totalRateInCents!,
        groupName: formData.groupName.trim() || undefined,
        contractLanguage: formData.contractLanguage.trim() || null,
      }).unwrap();

      toastElement?.show({
        severity: "success",
        summary: "Created!",
        detail: "Exploding fee schedule ruleset created successfully.",
      });
      navigate("/payer-rules");
    } catch (error: any) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.data?.message ||
          "Failed to create exploding fee schedule ruleset",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ExplodingFeeScheduleForm
      title="Create Exploding Fee Schedule Ruleset"
      submitLabel="Create Ruleset"
      submitIcon="pi pi-check"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
    />
  );
}
